import { Module } from '@nestjs/common';
import { RecruitmentService } from './recruitment.service';
import { RecruitmentController } from './recruitment.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Recruitment } from './recruitment.entity';
import { RecruitmentAdapter } from './dto/recruitment-adpater';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [

    TypeOrmModule.forFeature([Recruitment]),
    // forwardRef(() => ClusterModule),
  ],
  providers: [RecruitmentService, RecruitmentAdapter, ApplicationExceptionHandler,LogsService],
  controllers: [RecruitmentController]
})
export class RecruitmentModule { }
